<template>
  <MPopover
    :ref="`popover-${guid}`"
    trigger="click"
    :placement="placement"
    :disabled="disabled"
    @show="handleOpen"
    @hide="handleHide"
  >
    <template v-slot:trigger="{ show }">
      <slot name="trigger" :show="show">
        <div
          ref="buttonRef"
          role="button"
          tabindex="0"
          class="w-fit h-fit cursor-pointer"
          @keydown.stop.enter="handleClick"
        >
          <FlotoDot :bg="color.hex" class="cursor-pointer" :size="18" />
        </div>
      </slot>
    </template>
    <MRow :gutter="0">
      <MCol class="color-picker-container">
        <MRow>
          <MCol>
            <h6 class="text-primary"><slot name="heading" /></h6>
          </MCol>
        </MRow>
        <Sketch v-model="color"></Sketch>
        <MRow class="mt-4 justify-end" :gutter="0">
          <MButton variant="primary" rounded class="mx-2" @click="onSubmit">
            {{ $t('done') }}
          </MButton>
          <MButton variant="default" rounded @click="handleHide">
            {{ $t('cancel') }}
          </MButton>
        </MRow>
      </MCol>
    </MRow>
  </MPopover>
</template>

<script>
import { Sketch } from 'vue-color'
import { handleStoreFocus, handleHidePopOver } from '@utils/focus'
import { generateId } from '@utils/id'

export default {
  name: 'FlotoColorPicker',
  components: { Sketch },
  model: {
    event: 'change',
  },
  props: {
    value: { type: String, required: true },
    placement: {
      type: String,
      default() {
        return 'bottomLeft'
      },
    },
    disabled: { type: Boolean, default: false },
  },
  data() {
    this.guid = generateId()

    return {
      color: { hex: this.value },
      initialFocusedElement: undefined,
    }
  },
  watch: {
    value(newValue) {
      this.color = { hex: newValue }
    },
  },
  methods: {
    handleClick() {
      this.$refs.buttonRef.click()
    },
    handleOpen() {
      handleStoreFocus(this, this.guid)
    },
    handleHide() {
      handleHidePopOver(this, this.guid, this.initialFocusedElement)
      this.color = { hex: this.value }
    },
    onSubmit() {
      this.$emit('change', this.color.hex)
      this.handleHide()
    },
  },
}
</script>

<style lang="less" scope>
.color-picker-container {
  .vc-sketch {
    padding: 0;
    background-color: var(--form-overlay-bg);
    box-shadow: none;

    .vc-sketch-field {
      // stylelint-disable-next-line
      & .vc-input__input {
        color: var(--page-text-color);
        background: var(--page-background-color);
        border: 1px solid var(--border-color);
        box-shadow: none;
      }
    }
  }
}
</style>
